import Modal from '../../mini/Modal'
import React from 'react'
import { H2, P3 } from '../../styled/typography/typography'
import Button from '../../mini/Button'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import _Checkmark from '../../../static/images/Skills/checkmark.svg'
import { ModalStyles } from './styled'
import { loginUser } from '../../../actions/auth'
import { hideModal } from '../../../actions/_modal'

const GuardianSuccessModal = ({ linked, email, password }) => {
  const dispatch = useDispatch()

  const closeAndLogin = () => {
    dispatch(hideModal())
    dispatch(loginUser(email, password))
  }

  const handleClick = () => {
    if (linked) {
      closeAndLogin()
    } else {
      dispatch(hideModal())
      dispatch(push('/'))
    }
  }

  return (
    <Modal
      width={472}
      topPx={365}
      height={300}
      background={'transparent'}
      opacity={'1'}
      boxShadow={'0 0 30px 0 rgba(0,0,0,0.07)'}
    >
      <ModalStyles>
        <div className="center">
          <img alt="checkmark" src={_Checkmark} className="success-mark"/>
          <H2 style={{ marginBottom: '16px' }}>Account {linked ? "Linked!" : "Created!"}</H2>
          <P3 style={{ marginBottom: '30.2px' }}>You've successfully {linked ? "linked" : "created"} your Quest<span>™</span> Account!</P3>
          <Button
            text={linked ? "Continue" : "Go to Sign In"}
            className="quest-btn btn-a go uncap active"
            onClick={() => handleClick()}
          />
        </div>
      </ModalStyles>
    </Modal>
  )
}

export default GuardianSuccessModal
